import React, { useEffect, useState } from "react";
import {
  fetchPaymentTypesBalance,
  fetchMarketItems,
  fetchCollections,
  fetchPaymentMethods,
  handleError,
} from "../../utils";
import Button from "@origyn-sa/common-ui/src/components/atoms/Button";
import Grid from "@origyn-sa/common-ui/src/components/atoms/Grid";
import { H3 } from "@origyn-sa/common-ui/src/components/atoms/H/H.styled";
import StyledItemGrid from "@origyn-sa/common-ui/src/components/atoms/ItemGrid";
import PageTitle from "@origyn-sa/common-ui/src/components/atoms/PageTitle";
import ProductCard from "@origyn-sa/common-ui/src/components/molecules/ProductCard";
import SearchInput from "@origyn-sa/common-ui/src/components/molecules/SearchInput";
import Select from "@origyn-sa/common-ui/src/components/molecules/Select";
import Table from "@origyn-sa/common-ui/src/components/organisms/Table";
import { displayPrice } from "../../utils";
import InventoryStyled from "./Inventory.styled";
import { client, ICPClient } from "../../agent";
import { Principal } from "@dfinity/agent";
import { LinearProgress } from "@material-ui/core";
import { toast } from "react-toastify";
import { setCollections } from "@origyn-sa/common-ui/src/store/MarketplaceStore/collections";
import ListItemModal from "../NFTItem/ListItemModal";

const MarketplaceInventory = ({
  loggedInUser,
}: {
  loggedInUser: string | undefined;
}) => {
  const [loader, setLoader] = useState<boolean>(true);
  const [user, setUser] = useState<string | undefined>(loggedInUser);
  const [itemsList, setItemsList] = useState<any[]>([]);
  const [click, setClick] = useState<boolean>(false);
  const [pmBalances, setPmBalances] = useState<any[]>([]);
  const [collections, setCollections] = useState<any[]>([]);
  const [paymentMethods, setPaymentMethods] = useState<any[]>([]);
  const [isListModalOpened, setIsListModalOpened] = useState<boolean>(false);

  const reloadInventoryData = () => {
    console.debug("reloadInventoryData");
    Promise.all([
      fetchCollections()
        .then((collections: any) => {
          console.debug({ collections });
          setCollections(collections);
        })
        .catch(handleError),
      fetchPaymentMethods()
        .then((paymentsMethods: any) => {
          console.debug({ paymentsMethods });
          setPaymentMethods(paymentsMethods);
        })
        .catch(handleError),
    ]).finally(() => {
      setLoader(false);
    });
  };
  const reloadUserData = () => {
    console.debug({ user, msg: "reloadUserData" });
    if (!user) return;
    console.log(user);
    setLoader(true);
    fetchMarketItems(user)
      .then((data: any) => {
        console.log({ data });
        setItemsList(data);
      })
      .catch(handleError)
      .finally(() => {
        setLoader(false);
      });
    fetchPaymentTypesBalance(user)
      .then((pmAndBalances) => {
        console.debug(pmAndBalances);
        setPmBalances(pmAndBalances);
      })
      .catch((err) => {
        console.error({ err });
      })
      .finally(() => {
        setLoader(false);
      });
  };
  useEffect(() => {
    if (user) {
      reloadUserData();
    }
  }, [user]);

  useEffect(() => {
    setUser(loggedInUser);
  }, [loggedInUser]);

  useEffect(() => {
    reloadInventoryData();
    reloadUserData();
  }, []);
  console.log(itemsList);

  return (
    <InventoryStyled>
      {loader && (
        <LinearProgress
          style={{
            top: 0,
            position: "fixed",
            width: "100%",
            margin: "auto",
            left: 0,
          }}
        />
      )}
      <PageTitle>My inventory</PageTitle>

      {loggedInUser && (
        <div style={{ minWidth: "320px" }}>
          <span>
            To list an item for sale; You must <b>approve</b> the spender{" "}
            <b>{ICPClient.getCanisterId()}</b> with value <b>{loggedInUser}</b>{" "}
            in the NFT canister then click on List
          </span>
          <br />
          <br />
        </div>
      )}
      {/* <H3>Fungible tokens</H3>
      <div>
        <Table
          spacing={4}
          fullWidth
          values={[
            { label: "Token Symbol", colspan: "1" },
            { label: "Balance", colspan: "1" },
          ]}
          data={
            (pmBalances &&
              pmBalances.map((pmBalance: any) => [
                {
                  label: pmBalance.symbol,
                  colspan: "1",
                },
                {
                  colspan: "1",
                  label: pmBalance.balance / 10 ** pmBalance.decimal,
                },
              ])) ||
            []
          }
        />
      </div> */}
      <H3>
        Non fungible tokens{" "}
        {loggedInUser && (
          <Button
            small
            outlined={true}
            onClick={() => setIsListModalOpened(true)}
          >
            List
          </Button>
        )}
      </H3>
      <br />
      <Grid columns={5}>
        <Grid className='topGrid' columns={4}>
          <Grid
            columns={4}
            style={{
              gridColumnStart: 1,
              gridColumnEnd: 5,
            }}
          >
            <SearchInput
              className='gridSearchInput'
              placeholder='Search items, collections and accounts'
            />
            <Select small placeholder='Sort by' />
            <Button
              textBtn
              small
              className='displayButtonFilter'
              onClick={() => setClick(!click)}
            >
              FILTER
            </Button>
          </Grid>

          <StyledItemGrid
            style={{ gridColumnStart: 1, gridColumnEnd: 5 }}
            maxColumns={4}
          >
            {itemsList.length === 0 && <div>No items.</div>}
            {itemsList.map((item: any) => (
              <ProductCard
                key={item.id}
                productUrl={`/market/${item.canisterId}/${item.id}`}
                productImage={item.image || ""}
                productName={item.name || ""}
                productCase={`ID: ${item.id}` || ""}
                owner={item.owner}
                price={displayPrice(item)}
              />
            ))}
          </StyledItemGrid>
        </Grid>
      </Grid>
      <ListItemModal
        paymentMethods={paymentMethods}
        open={isListModalOpened}
        collections={collections}
        onClose={() => {
          setIsListModalOpened(false);
        }}
        onList={(values: any) => {
          try {
            console.debug("onList", values);
            const selectedPm = paymentMethods.find(
              (pm) => pm._principal === values.paymentMethod
            );
            if (!selectedPm || !loggedInUser) {
              console.error("selected payment", selectedPm);
              toast.error("Wrong payment method selected / Not connected");
              return;
            }
            console.log("pre addListing", client.actor.addListing);
            // client.actor.whoami().then(console.error);
            const newListing = {
              // collectionItem = listing.collectionItem;
              // enabled = listing.enabled;
              // listingPrice = listing.listingPrice;
              // paymentMethodPrincipal = listing.paymentMethodPrincipal;
              // recipient_identifier = listing.recipient_identifier;
              // seller = msg.caller;
              // updatedAt = now;
              seller: Principal.fromText(loggedInUser), // IDL.Principal,*/}
              listingPrice:
                Number(values.listingPrice) * 10 ** selectedPm.decimal,
              enabled: true,
              updatedAt: 0, // IDL.Int,*/}
              paymentMethodPrincipal: Principal.fromText(values.paymentMethod), // IDL.Principal,*/}
              ownerWhenListed: Principal.fromText("aaaaa-aa"),
              collectionItem: {
                collectionPrincipal: values.collection._principal,
                identifier: values.tokenId,
              },
            };
            console.debug({ newListing });
            client.actor
              .addListing(newListing)
              .then((e: any) => {
                console.log({ e });
                toast.success(`Listing added: ${e}`);
              })
              .catch((err: any) => {
                console.error({ err });
                toast.error(`Failed to add listing ${err}`);
              })
              .finally(() => {
                setIsListModalOpened(false);
                reloadUserData();
              });
          } catch (e: any) {
            console.error({ e });
          }
          // finally {
          // setIsListModalOpened(false);
          // }
        }}
      />
    </InventoryStyled>
  );
};

export default MarketplaceInventory;
